import axiosInstance from 'services/axiosInstance';
import { ICommonResponse, IResponse } from 'services/types';
import { IPusherConfig } from 'services/common/types';

export const getAppLogo = (): IResponse<ICommonResponse<string>> =>
  axiosInstance.request({
    url: 'Common/baseAppLogo',
    method: 'GET',
  });

export const fixPhoneFormat = (phone: string): IResponse<ICommonResponse<string>> =>
  axiosInstance.request({
    method: 'POST',
    url: '/Common/beautifyPhoneNumber',
    data: { data: phone },
  });

export const getClientPortalPusher = (): IResponse<IPusherConfig> =>
  axiosInstance.request({
    method: 'GET',
    url: '/ClientPortalChats/get-pusher-settings',
  });

export const getAuthAppPusher = (): IResponse<IPusherConfig> =>
  axiosInstance.request({
    method: 'GET',
    url: '/Common/get-auth-pusher-settings',
  });
